module.exports = "images/scroll_arrow_next.png";